import React from 'react';
import { Calendar, Shield, Truck } from 'lucide-react';

const FeaturesBar = () => {
  return (
    <section className="bg-gray-50 py-6 md:py-8 border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          <div className="flex items-center gap-3 md:gap-4">
            <div className="w-11 h-11 md:w-14 md:h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Calendar className="w-5 h-5 md:w-7 md:h-7 text-orange-500" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-sm md:text-base">Réservation Facile</h3>
              <p className="text-xs md:text-sm text-gray-500">Formules à la carte — Tout inclus ou retrait en Drive</p>
            </div>
          </div>
          <div className="flex items-center gap-3 md:gap-4">
            <div className="w-11 h-11 md:w-14 md:h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Shield className="w-5 h-5 md:w-7 md:h-7 text-orange-500" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-sm md:text-base">Matériel de Qualité</h3>
              <p className="text-xs md:text-sm text-gray-500">Bâche 500g/m², anti-feu, assurance incluse</p>
            </div>
          </div>
          <div className="flex items-center gap-3 md:gap-4">
            <div className="w-11 h-11 md:w-14 md:h-14 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Truck className="w-5 h-5 md:w-7 md:h-7 text-orange-500" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 text-sm md:text-base">Livraison & Installation</h3>
              <p className="text-xs md:text-sm text-gray-500">Service complet en Normandie</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesBar;
